import React from "react";
import { Outlet } from "react-router-dom";
import Nav from "../GuestPages/Nav";
import Footer from "../GuestPages/Footer";





export default function General () {
    return (
        <>
        <Nav />
        <Outlet />
        <Footer />
        </>
    )
}